import {
  Box,
  FormLabel,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import googleImg from "../../assets/landing_page/Images/googleImg.png";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import Logo from "../../assets/landing_page/Planshare.png";
import {VisibilityOutlined as VisibilityOutlinedIcon, VisibilityOffOutlined as VisibilityOffOutlinedIcon } from "@mui/icons-material";
export const Login = () => {
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;
    // Email validation
    if (!email) {
      tempErrors.email = "Email is required";
    //  toast.error("Email is required");
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      //tempErrors.email = "Email address is invalid.";

      isValid = false;
    }
    if (!password) {
      tempErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      handleSignIn();
    }
  };
  const handleSignIn = async () => {
    try {
      const payload = {
        email: email,
        password: password,
      };

      const response = await http.post("/auth_service/usesr/Login", payload);

      if (
        response.data.message ===
        "An Email has been sent to your account. Please verify."
      ) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          navigate("/Otp");
        }, 2000);
        localStorage.setItem("field_email", email);
      } else if (response.data.success === true) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("email", response.data.user.email);
        localStorage.setItem("user_name", response.data.user.user_name);
        localStorage.setItem("user_id", response.data.user.user_id);
        localStorage.setItem("role", response.data.user.role);
        localStorage.setItem(
          "user_picture",
          response.data.user.uploaded_picture_path
        );

        const redirectUrl = localStorage.getItem("redirectAfterLogin");
        if (redirectUrl) {
          // Navigate to the stored URL
          localStorage.removeItem("redirectAfterLogin"); // Clear the stored URL
          navigate(redirectUrl);
          window.location.reload();
        } else {
          // Check user role and navigate accordingly
          const userRole = response.data.user.role;
          if (userRole === "Admin") {
            navigate("/admin");
          } else {
            navigate("/home/dashboard");
          }
          window.location.reload();
        }
      } else if (response.data.success === false) {
        toast.error("Email or password incorrect");
      }
    } catch (error) {
    console.error("Error during sign in:", error);

    // ✅ Handle no internet / network error
    if (error.message === "Network Error" || !error.response) {
      toast.error("No internet connection or server not reachable. Please try again later.");
      return;
    }

    // ✅ Handle timeout (if configured in axios)
    if (error.code === "ECONNABORTED") {
      toast.error("The request timed out. Please try again.");
      return;
    }

    // ✅ Handle server errors (4xx, 5xx)
    const serverMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Login failed due to server error.";

    toast.error(serverMessage);
  }
};

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundImage: `url('./background.jpg')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "rgba(255, 255, 255, 0.2)", // White overlay with 50% opacity
    backgroundBlendMode: "overlay",
      }}>
      <Box
        sx={{
          width: { xs: "80%", md: "27%" },
          border: "1px solid #E7E8EA",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          background: "#FFFFFF",
          borderRadius: "12px",
          p: "40px",
          pb: "10px",
        }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
                src={Logo}
                alt='planshare logo'
                onClick={()=>(window.location.href = "https://planshare.ai")}
                style={{ width: "140px", height: "32px", cursor: "pointer" }}
              />
        </Box>
        <Typography
          sx={{
            my: 2,
            fontWeight: "600",
            fontSize: "20px",
            color: "#040815",
          }}>
          Welcome Back 👋
        </Typography>
        <Typography
          sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}>
          Log in to your account and get back to managing your projects.
        </Typography>
        <Box
          sx={{
            my: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Email Id
          </FormLabel>
          <TextField
            placeholder='Enter Email ID'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}></TextField>
            
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Password
          </FormLabel>
          <OutlinedInput
            placeholder='Enter Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
           // error={!!errors.password}
            helperText={errors.password}
            sx={{
              my: 2,
              "& input": {
                height: "10px",
              },
            }}
            error={!!errors.password} 
            type={showPassword1 ? "text" : "password"}
            
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => setShowPassword1(!showPassword1)}
                  edge='end'>
                  {showPassword1 ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </InputAdornment>
            }
            label='Password'
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }} />
          <Box sx={{ my: 2, marginTop :-2,marginLeft :2}}>
         {errors.password && (
    <FormHelperText error>{errors.password}</FormHelperText>
  )}
  </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              my: { xs: "0", sm: "15px" },
            }}>
            <Link
              to={"/ForgotPassword"}
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: "500",
                fontSize: "12px",
                textDecoration: "none",
                color: "#040815",
              }}>
              Forget Password?
            </Link>
          </Box>
          <Button
            sx={{
              background: "#FF2800",
              color: "#FFFFFF",
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "600",
              "&:hover": {
                background: "#e64a19",
              },
            }}
            onClick={handleSubmit}>
            
            Sign In
          </Button>
          <Typography
            sx={{
              color: "#0F1419",
              textAlign: "center",
              fontWeight: "400",
              fontSize: "12px",
              my: 1,
            }}>
            Don’t have an account?{" "}
            <Link
              to={"/Reg"}
              style={{
                fontWeight: "600",
                fontSize: "12px",
                position: "relative",
                color: "#FF2800",
              }}>
              Create free account
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
